export default {
  getagendamentos: state => state.agendamentos,
  getagendamentoSelecionado: state => state.agendamentoSelecionado,
  getRotas: state => state.rotas,
  getOperadores: state => state.operadores,
  getRamais: state => state.ramais,
  getOperador: state => state.operador,
  getDepartaments: state => state.departamentos,
  getDepatament: state => state.departamento,
  getGruposDeRotas: state => state.gruposDeRotas
}
